// LIVE
// export const BASEURL = "https://miraj-api.binarynumbers.io/api";
// export const IMAGEURL = "https://miraj-api.binarynumbers.io";
// DEV
export const BASEURL = "https://api.cinepolisgulf.com/api/";
// export const BASEURL = "https://uat-api-cinepolis.cinepolisgulf.com/api/";
// export const BASEURL = "http://localhost:8001/api";
export const IMAGEURL = "https://cinepoligulf-1.s3.ap-south-1.amazonaws.com/uploads/images/";
export const PROMOTIONS_IMAGEURL = "https://cinepoligulf-1.s3.ap-south-1.amazonaws.com/uploads/images/promotions/";
export const BANNERS_IMAGEURL = "https://cinepoligulf-1.s3.ap-south-1.amazonaws.com/uploads/images/banners/";
export const MOVIES_IMAGEURL = "https://cinepoligulf-1.s3.ap-south-1.amazonaws.com/uploads/images/movies/";
export const CINEMAS_IMAGEURL = "https://cinepoligulf-1.s3.ap-south-1.amazonaws.com/uploads/images/cinemas/";
export const SCREENTYPES_IMAGEURL = "https://cinepoligulf-1.s3.ap-south-1.amazonaws.com/uploads/images/screentypes/";
export const CONCESSIONS_IMAGEURL = "https://cinepoligulf-1.s3.ap-south-1.amazonaws.com/uploads/images/concessions/";
export const RECEIPTS_URL = "https://cinepoligulf-1.s3.ap-south-1.amazonaws.com/uploads/images/receipts/";
export const API_VERSION = "v1.0";
export const S3BASEURL = "";